import OrderAddStockPage from './order-add-stock';

export default OrderAddStockPage;